import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import logo from "@/assets/velocity-logo-header.png";
import TypewriterCursive from "@/components/TypewriterCursive";

const links = [
  { label: "About", href: "/about" },
  { label: "Services", href: "/services" },
  { label: "Fleet", href: "/fleet" },
  { label: "Operations", href: "/operations" },
  { label: "Safety", href: "/safety" },
  { label: "Contact", href: "/contact" },
];

const Footer = () => (
  <footer id="site-footer" className="relative overflow-hidden">
    {/* Gradient background: white to navy */}
    <div className="absolute inset-0 bg-gradient-to-b from-white via-[hsl(215,35%,85%)] to-[hsl(218,55%,10%)]" />

    {/* Top accent */}
    <div className="relative h-[2px] bg-gradient-to-r from-transparent via-teal/40 to-transparent" />

    {/* CTA band */}
    <div className="relative border-b border-navy-deep/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div>
          <h3 className="font-display text-3xl md:text-4xl text-navy-deep tracking-tight mb-3">
            Ready to <span className="accent-text">work together?</span>
          </h3>
          <p className="text-navy-deep/50 font-body text-lg font-light">
            Let's discuss your offshore personnel transportation requirements.
          </p>
        </div>
        <Link
          to="/contact"
          className="group inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-teal to-teal-light text-navy-deep text-[12px] font-bold tracking-[1.5px] uppercase rounded-full hover:shadow-xl hover:shadow-teal/25 transition-all duration-300 font-body flex-shrink-0"
        >
          Get in Touch
          <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
        </Link>
      </div>
    </div>

    <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 py-14">
      <div className="flex flex-col lg:flex-row justify-between gap-12">
        <div className="max-w-sm">
          <img src={logo} alt="Velocity Offshore" className="h-48 mb-1" />
          <TypewriterCursive />
        </div>
        <div className="flex flex-wrap gap-x-12 gap-y-4">
          {links.map((link) => (
            <Link
              key={link.label}
              to={link.href}
              className="text-sm text-navy-deep/70 hover:text-teal transition-colors font-body"
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </div>

    <div className="relative border-t border-primary-foreground/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between items-center gap-3">
        <p className="text-xs text-primary-foreground/30 font-body">© 2026 Velocity Offshore Holdings LLC. Est. 2026. All rights reserved.</p>
        <div className="flex items-center gap-4 flex-wrap justify-center">
          <p className="text-xs text-primary-foreground/30 font-body">Majuro, Marshall Islands • Houston, TX • Global Operations</p>
          <Link to="/terms" className="text-xs text-primary-foreground/30 hover:text-teal/70 font-body transition-colors">Terms</Link>
          <Link to="/privacy" className="text-xs text-primary-foreground/30 hover:text-teal/70 font-body transition-colors">Privacy</Link>
          <Link to="/cookies" className="text-xs text-primary-foreground/30 hover:text-teal/70 font-body transition-colors">Cookies</Link>
          <Link to="/auditor-login" className="text-xs text-primary-foreground/30 hover:text-teal/70 font-body transition-colors">Auditor Login</Link>
          <Link to="/client-login" className="text-xs text-primary-foreground/20 hover:text-teal/50 font-body transition-colors">Admin</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
